import copy from 'utils-copy-error';
import { ClientInstance, ExtraType } from './types';

class SlardarLogger {
  private client;
  private commonExtra;

  constructor(client: ClientInstance, commonExtra?: ExtraType) {
    this.client = client;
    this.commonExtra = commonExtra;
  }

  /**
   * Errors need report immediately
   * @param error `Error` object
   * @param message Extra description
   * @param extra Extra info to report
   */
  fatal(error: Error | unknown, message?: string, extra?: ExtraType) {
    this._capture('__Fatal__', error, message, extra);
  }

  /**
   * Regular Errors
   * @param error `Error` object
   * @param message Extra description
   * @param extra Extra info to report
   */
  error(error: Error | unknown, message?: string, extra?: ExtraType): void {
    this._capture('__CustomError__', error, message, extra);
  }

  /**
   * Debug
   * @param content log content with `${PID}_` prefix;
   * @param extra Extra info to report
   */
  debug(content: string, extra?: ExtraType): void {
    extra = this._parseExtra(extra);
    this.client?.('sendLog', {
      level: 'debug',
      content,
      extra,
    });
  }

  /**
   * Custom Event
   * @param content log content with `${PID}_` prefix;
   * @param extra Extra info to report
   *
   */
  info(name: string, extra?: ExtraType): void {
    const categories = this._parseExtra(extra);
    const metrics = {} as ExtraType;
    for (const key in categories) {
      if (Object.prototype.hasOwnProperty.call(categories, key)) {
        if (typeof categories[key] === 'number') {
          metrics[key] = categories[key];
        }
      }
    }

    this.client?.('sendEvent', { type: 'event', name, metrics, categories });
  }

  // Merge commonTags with incoming tags and format relevant data
  private _parseExtra = (extra?: ExtraType): ExtraType => {
    const tempExtra = { ...this.commonExtra, ...extra };
    const resExtra = {} as ExtraType;
    try {
      for (const key in tempExtra) {
        if (Object.prototype.hasOwnProperty.call(tempExtra, key)) {
          resExtra[key] =
            typeof tempExtra[key] === 'string' || typeof tempExtra[key] === 'number'
              ? tempExtra[key]
              : JSON.stringify(tempExtra[key]);
        }
      }
    } catch (error) {}
    return resExtra;
  };

  private _capture = (level: '__Fatal__' | '__CustomError__', error: any, message = '', extra?: ExtraType): void => {
    try {
      const _error = copy(error);
      extra = this._parseExtra(extra);
      _error.message = `${level} | ${_error?.message} | ${message}`;
      this.client?.('captureException', _error, extra);
    } catch (e) {}
  };
}

export default SlardarLogger;
